import { createFullMask } from '@/utils/tool';
import Vue from 'vue';
export default {
    bind: function(el, binding) {
        el.addEventListener('click', () => {
            createFullMask(binding.value);
        });
    }
};
Vue.directive('throttle',{
    inserted:(el,binding)=>{
        let delay= binding.args
        if(!delay) delay= 500 
        let timer;
        el.addEventListener('click',()=>{
            if(timer) return
            binding.value()
            timer= setTimeout(()=>{
                timer = null
            },delay)
        })
    }
})

